(function () {
  'use strict';

  const HEADER_OFFSET = 90;
  const TOC_BASE_TOP = 120;

  function getAnchors() {
    return Array.from(document.querySelectorAll('[data-science-anchor][data-anchor-id]'));
  }

  function setActiveLink(root, anchorId, groupId) {
    const links = root.querySelectorAll('[data-toc-link]');
    let hasGroupMatch = false;
    let hasTargetMatch = false;

    if (groupId) {
      links.forEach((link) => {
        const linkGroup = link.getAttribute('data-group-id');
        if (linkGroup === groupId) {
          hasGroupMatch = true;
        }
      });
    }

    if (anchorId) {
      links.forEach((link) => {
        const linkTarget = link.getAttribute('data-target-id');
        if (linkTarget === anchorId) {
          hasTargetMatch = true;
        }
      });
    }

    // If current visible section doesn't map to any TOC link,
    // keep the previous active state instead of clearing all items.
    if (!hasGroupMatch && !hasTargetMatch) return;

    links.forEach((link) => {
      const linkTarget = link.getAttribute('data-target-id');
      const linkGroup = link.getAttribute('data-group-id');
      const isActive = hasGroupMatch ? linkGroup === groupId : linkTarget === anchorId;
      link.classList.toggle('is-active', isActive);
    });
  }

  function scrollToAnchor(anchorId) {
    const target = document.getElementById(anchorId);
    if (!target) return;
    const targetTop = target.getBoundingClientRect().top + window.scrollY - HEADER_OFFSET;
    window.scrollTo({ top: targetTop, behavior: 'smooth' });
  }

  function setupScienceLayout(section, anchors) {
    const referenceSection = section.closest('.shopify-section');
    if (!referenceSection) return;
    if (referenceSection.parentElement?.classList.contains('science-layout__toc')) return;

    const parent = referenceSection.parentElement;
    if (!parent) return;

    const contentSections = Array.from(
      new Set(
        anchors
          .map((anchor) => anchor.closest('.shopify-section'))
          .filter((el) => el instanceof HTMLElement)
      )
    );
    if (!contentSections.length) return;

    const layout = document.createElement('div');
    layout.className = 'science-layout';

    const inner = document.createElement('div');
    inner.className = 'science-layout__inner';

    const tocCol = document.createElement('div');
    tocCol.className = 'science-layout__toc';

    const contentCol = document.createElement('div');
    contentCol.className = 'science-layout__content';

    layout.appendChild(inner);
    inner.appendChild(tocCol);
    inner.appendChild(contentCol);
    referenceSection.before(layout);

    tocCol.appendChild(referenceSection);
    contentSections.forEach((contentSection) => {
      if (contentSection.parentElement) {
        contentCol.appendChild(contentSection);
      }
    });
  }

  function initToc(section) {
    const toc = section.querySelector('[data-science-toc]');
    if (!toc) return;
    if (toc.dataset.initialized === 'true') return;

    const anchors = getAnchors();
    if (anchors.length === 0) return;
    setupScienceLayout(section, anchors);

    function updateActiveFromScrollPosition() {
      const thresholdTop = HEADER_OFFSET + 20;
      let activeAnchor = anchors[0];

      anchors.forEach((anchor) => {
        if (anchor.getBoundingClientRect().top <= thresholdTop) {
          activeAnchor = anchor;
        }
      });

      if (!activeAnchor) return;
      const activeId = activeAnchor.getAttribute('data-anchor-id');
      const activeGroup = activeAnchor.getAttribute('data-reference-group') || activeId;
      if (!activeId) return;
      setActiveLink(toc, activeId, activeGroup);
    }

    const links = toc.querySelectorAll('[data-toc-link]');
    links.forEach((link) => {
      link.addEventListener('click', (event) => {
        event.preventDefault();
        const anchorId = link.getAttribute('data-target-id');
        if (!anchorId) return;
        scrollToAnchor(anchorId);
      });
    });

    const observer = new IntersectionObserver(
      (entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        updateActiveFromScrollPosition();
      },
      {
        root: null,
        threshold: [0.2, 0.35, 0.6],
        rootMargin: '-20% 0px -55% 0px',
      }
    );

    anchors.forEach((anchor) => observer.observe(anchor));
    updateActiveFromScrollPosition();
    window.addEventListener('scroll', updateActiveFromScrollPosition, { passive: true });

    toc.dataset.initialized = 'true';
  }

  function initAll() {
    const sections = document.querySelectorAll('[data-science-reference]');
    sections.forEach((section) => initToc(section));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    if (!(event.target instanceof HTMLElement)) return;
    const section = event.target.querySelector('[data-science-reference]');
    if (!section) return;
    initToc(section);
  });
})();
